export const findLatestOrderTaskByServiceName = (tasksArray, serviceName) => {
  if (
    !tasksArray ||
    !tasksArray.length ||
    typeof serviceName === 'undefined' ||
    serviceName === null
  ) {
    return {};
  }
  const taskArrayForSort = [...tasksArray];
  taskArrayForSort.sort((a, b) => {
    if (a.createdAt > b.createdAt) {
      return -1;
    }
    if (a.createdAt < b.createdAt) {
      return 1;
    }
    return 0;
  });
  return taskArrayForSort.find((task) => task.type === serviceName);
};
